import React, {useState} from 'react';
// import {useNavigate} from 'react-router-dom';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import SlideItem from './slideItem';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';
import classNames from 'classnames';

import StepTwo from './stepTwo';
import StepThree from './stepThree';
import useGetPlans from '../../../services/hookService/plans/getPlans/useGetPlans';
import DotsLoading from '../../../components/dotsLoading';

export interface IChoosed {
  guid: string;
  price: number;
  discounted_price?: number;
  discountPrice: number | null;
  discount_amount: number | null;
}
const AccounPromotion = () => {
  const [choosed, setchoosed] = useState<IChoosed>();
  const [paymentWay, setpaymentWay] = useState<string>();
  const [stepChoosed, setStepChoosed] = useState<string>();
  const {isLoading, data} = useGetPlans();

  return (
    <div className="flex flex-col w-full h-full  gap-4">
      <CustomHeader
        preIcon="icon-nameArrow---Right"
        title="ارتقا فروشگاه"
        isActiveRightIcon
      />

      <p className="px-3 py-0 m-0   text-gray-900 font-Medium text-md">
        پکیج فعال:{' '}
        <span>
          {data?.plans_data.find(
            item => item.plan_type === data?.user_active_plan.plan_type,
          )?.title || 'پکیج رایگان'}
        </span>
      </p>
      <section className="w-full h-full snap-mandatory snap-x py-3 gap-3 flex overflow-x-auto px-5 z-20">
        {isLoading ? (
          <div className="flex w-full justify-center">
            <DotsLoading />
          </div>
        ) : (
          <>
            {data?.plans_data.map(item => (
              <SlideItem
                user_active_plan={data?.user_active_plan}
                key={item.guid}
                is_active_discount={item.is_active_discount}
                packageName={item.title}
                id={item.plan_type}
                planGuid={item.guid}
                plan_type={item.plan_type}
                packageImage={imageAccountConvertor[item.plan_type]}
                packagePrice={item.price}
                discountPrice={item.discount_price}
                discount_amount={item.discount_amount}
                description={item?.plan_info?.description}
                elements={item?.plan_info?.plans_access}
                choosed={choosed}
                stepChoosed={stepChoosed}
                setStepChoosed={setStepChoosed}
                setchoosed={setchoosed}
              />
            ))}
          </>
        )}

        {choosed !== undefined && stepChoosed && (
          <div
            className={classNames(
              'flex w-full fixed rounded-t-[8px] px-2 bg-white bottom-0 gap-2 right-0 left-0 flex-col justify-between py-2 shadow-dropShadow',
            )}
          >
            {stepChoosed === 'stepOne' && (
              <StepTwo setStepChoosed={setStepChoosed} choosed={choosed} />
            )}

            {stepChoosed === 'StepThree' && (
              <StepThree
                choosed={choosed}
                paymentWay={paymentWay}
                setpaymentWay={setpaymentWay}
                setStepChoosed={setStepChoosed}
              />
            )}
          </div>
        )}
      </section>
      <MainFooter />
    </div>
  );
};

export default AccounPromotion;
const imageAccountConvertor: Record<string, string> = {
  free: 'https://farm-upgradeaccount.s3.ir-thr-at1.arvanstorage.ir/freeAccount.svg',
  level_1:
    'https://farm-upgradeaccount.s3.ir-thr-at1.arvanstorage.ir/oneMonthAccount.svg',
  level_2:
    'https://farm-upgradeaccount.s3.ir-thr-at1.arvanstorage.ir/threeMonthAccount.svg',
  level_3:
    'https://farm-upgradeaccount.s3.ir-thr-at1.arvanstorage.ir/sixMonthAccount.svg',
};
